import script from "./SelectExhibition.vue?vue&type=script&setup=true&lang=js"
export * from "./SelectExhibition.vue?vue&type=script&setup=true&lang=js"

import "./SelectExhibition.vue?vue&type=style&index=0&id=3c26fb2a&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-3c26fb2a"]])

export default __exports__